export default __webpack_public_path__ + "static/media/ic_config-product-type.03138e78.svg";